export default "__VITE_ASSET__BT9sTy_y__"